.question {
  position: relative;
  z-index: 1;
  /* Edge + chrome clearance is handled by the live stage safe-area. */
  padding: 0;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  /* Fill the live safe box, not the raw viewport (100vh overflows the
   * safe area and clips at the bottom). */
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--token-space-xl);
}

.empty {
  position: relative;
  z-index: 1;
  padding: var(--token-space-2xl);
  font-family: var(--token-font-ui);
}

.header {
  display: flex;
  gap: var(--token-space-md);
}

.navButton {
  min-height: var(--token-touch-min);
  padding: var(--token-space-sm) var(--token-space-lg);
  border-radius: var(--token-radius-pill);
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.35);
  color: var(--token-text-primary);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  font-family: inherit;
  cursor: pointer;
}

.placeholder {
  background: rgba(255, 255, 255, 0.6);
  border-radius: var(--token-radius-card-inner);
  padding: var(--token-space-2xl);
  text-align: center;
  font-style: italic;
}

.card {
  background: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  border: 1.5px solid var(--token-accent);
  border-radius: var(--token-radius-card);
  padding: var(--token-space-2xl);
  box-shadow:
    0 30px 60px -20px rgba(8, 18, 12, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.card h2 {
  font-family: var(--token-font-display);
  font-size: clamp(28px, 3vw, 56px);
  margin: 0 0 var(--token-space-md);
}

.prompt {
  font-size: clamp(20px, 2vw, 36px);
  line-height: 1.4;
  margin: 0 0 var(--token-space-xl);
}

.answer {
  background: var(--token-accent);
  color: var(--token-card-bg);
  padding: var(--token-space-md) var(--token-space-xl);
  border-radius: var(--token-radius-pill);
  font-family: var(--token-font-display);
  font-size: clamp(22px, 2.4vw, 40px);
  display: inline-block;
  animation: fadeIn 0.5s ease;
}

.hint {
  opacity: 0.7;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
